/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AutoWithdrawalCurrencyInfo { 
    walletId: string;
    currencyName: string;
    currencyTicker: string;
    chainName: string;
    autoWithdrawalAddress?: string | null;
    autoWithdrawalAmount?: number | null;
    isAutoWithdrawalEnabled: boolean;
}

